/* src/app/shared/orders-modal/orders-modal.component.scss */
.content-wrapper {
  margin: 25px;
  min-height: calc(100% - 110px);
}
.title {
  font-weight: 600;
}
.border-bottom {
  border-bottom: 2px solid var(--ion-color-primary);
  margin-left: -5px;
}
.opacity {
  opacity: 0.5;
}
.text {
  padding: 5px 5px 5px 0;
  white-space: nowrap;
  width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.quantityTitle {
  text-align: center;
  position: relative;
  bottom: -5px;
  font-size: 14px;
  min-width: 40px;
}
.returnFields {
  position: relative;
  bottom: -2px;
  margin-left: 5px;
}
.quantity {
  text-align: center;
  background-color: var(--ion-color-light-shade);
  width: 40px;
  height: 20px;
}
.quantity ion-input {
  width: 40px;
  height: 20px;
  --padding-top: 0;
  --padding-start: 0;
  --padding-bottom: 0;
  --padding-end: 0;
  min-height: unset !important;
}
.save-button {
  margin: 0 25px;
}
::ng-deep .refresher-pulling,
::ng-deep .refresher-refreshing,
::ng-deep .refresher-completing {
  margin-top: 42px;
}
ion-refresher-content {
  margin-top: 100px;
}
@media only screen and (min-width: 350px) {
  .text {
    width: 125px;
  }
}
@media only screen and (min-width: 400px) {
  .text {
    width: 175px;
  }
}
@media only screen and (min-width: 500px) {
  .text {
    width: fit-content;
  }
}
/*# sourceMappingURL=orders-modal.component.css.map */
